module.exports = __webpack_public_path__ + "img/2.5ffca1de.jpg";